export default class customStorage {
  // 获取localStorage中的值
  static getItem<T>(key: string): T | null {
    const item = localStorage.getItem(key);
    try {
      return item ? (JSON.parse(item) as T) : null;
    } catch (error) {
      console.error(`Error parsing item for key "${key}":`, error);
      return null;
    }
  }

  // 设置localStorage中的值
  static setItem<T>(key: string, value: T): void {
    localStorage.setItem(key, JSON.stringify(value));
  }

  // 移除localStorage中的项
  static removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  // 批量新增或更新
  static batchSetItem<T>(items: { [key: string]: T }): void {
    Object.keys(items).forEach((key) => {
      this.setItem(key, items[key]);
    });
  }

  // 批量删除
  static batchRemoveItems(keys: string[]): void {
    keys.forEach((key) => {
      this.removeItem(key);
    });
  }

  // 更新localStorage中的值
  // 如果项不存在，则等同于新增
  static updateItem<T>(key: string, newValue: T): void {
    this.setItem(key, newValue);
  }

  // 批量更新
  static batchUpdateItems<T>(updates: { [key: string]: T }): void {
    this.batchSetItem(updates);
  }

  // 清空localStorage
  static clear(): void {
    localStorage.clear();
  }
}
